export default __webpack_public_path__ + "static/media/incubator.ef61f079.svg";